module.exports = __webpack_public_path__ + "media/images/logo-9591e3e2971f0eb7120dc42a2eb81b15.svg";